import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import PaiLink from '../base-components/pai-link';

interface Props {
  open: boolean;
  variant?: 'default' | 'warning' | 'error';
  dialogTitle: string;
  cancelButtonText?: string;
  proceedButtonText: string | React.ReactNode;
  loading?: boolean;
  proceedButtonDisabled?: boolean;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
  children?: React.ReactNode;

  handleClose?(): void;

  handleProceed(): void;
}

const BasicActionDialog: React.FC<Props> = ({
  open,
  variant = 'default',
  dialogTitle,
  cancelButtonText,
  proceedButtonText,
  handleClose,
  handleProceed,
  loading,
  maxWidth,
  proceedButtonDisabled,
  children,
}) => {
  const { classes, cx } = useStyles();

  return (
    <Dialog open={open} fullWidth={true} maxWidth={maxWidth} classes={{ paper: classes.paper }} transitionDuration={0}>
      <DialogTitle className={cx(classes.title, variant)}>
        <Typography className={classes.titleText}>{dialogTitle}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>{children}</DialogContent>
      <DialogActions className={classes.actions}>
        {!_.isNil(cancelButtonText) && !_.isNil(handleClose) ? (
          <PaiLink text={cancelButtonText} size={'sm'} underline={'always'} action={handleClose} />
        ) : null}
        <PaiButton text={proceedButtonText} action={handleProceed} disabled={loading || proceedButtonDisabled} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    '&.default': {
      background: theme.palette.primary.main,
    },
    '&.warning': {
      background: theme.palette.warning.main,
    },
    '&.error': {
      background: theme.palette.error.main,
    },
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '16px 16px 20px 16px !important',
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 16px 20px 16px',
  },
}));

export default BasicActionDialog;
